import React from "react";

import vitamins from "../../assets/images/vitamins.svg";
import pain from "../../assets/images/pain.svg";
import crisis from "../../assets/images/crisis.svg";
import hydration from "../../assets/images/hydration.svg";

const Offer = () => {
  return (
    <div className="lg:px-20 px-5 text-text_color">
      <p className="font-Airbnb font-bold text-center lg:text-title text-title_mobile">
        What We Offer
        <span className="font-sora text-sm"> &#8212;&#8212;&#8212;</span>{" "}
      </p>
      <div className="w-full flex justify-around items-stretch content-center flex-wrap lg:flex-row flex-col pt-10 lg:pt-10">
        {offers.map((data, index) => (
          <div key={index} className="lg:w-2/5 py-4 lg:py-6">
            <div className="flex justify-center content-start items-stretch flex-col lg:flex-row">
              <div className="w-1/2">
                {" "}
                <img
                  src={data.icon}
                  className={`bg-opacity-10 ${
                    index === 2 ? "p-3" : "p-2"
                  } rounded-full ${
                    index === 0
                      ? "bg-red-400 "
                      : index === 1
                      ? "bg-yellow-400 "
                      : index === 2
                      ? "bg-blue-400 "
                      : "bg-green-400 "
                  }`}
                  alt={data.title}
                />
              </div>
              <div className="w-auto pt-4 lg:pt-0">
                <p className="text-left font-Airbnb font-bold pb-4 lg:text-offer-title text-offer-title-mobile">
                  {data.title}
                </p>
                <p
                  className="font-Airbnb font-normal text-left lg:text-offer-text text-text-mobile opacity-70"
                  style={{ fontSize: "15px" }}
                >
                  {data.text}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Offer;
const offers = [
  {
    title: "Aggressive Hydration",
    text: "At our SCD Center, we offer Medically proven fluid expansion PRO-ACTIVELY, before crisis sets in. 90% plus of Crisis are mediated by DEHYDRATION.  We have pure 100% Normal Saline,  Dextrose infused fluids both in various volumes: 250ml,500mland also 1 L sizes.  SCD Pts are expected to be hydrated bi- monthly to help alleviate any Crisis.",
    icon: hydration,
  },
  {
    title: "Crisis Reducing Medications",
    text: "FDA-approved Crisis Reducing Medication such as Hydroxyurea (Droxia, Hydrea, Silkos) and voxelotor (Oxbryta) prevent abnormal red blood cells from forming. This reduces the number of painful crises from sickling blood cells.",
    icon: crisis,
  },
  {
    title: "Vitamins and Amino Acids",
    text: "Our providers have abundant stocks of CUSTOMIZED AMINO ACID BLENDS of GLUTAMINE, LEUCINE,ISOLEUCINE and other proprietary BLENDS in addition to the old reliables of FOLIC ACID,  B12 AND THIAMINES. Our goal is to provide enough Antioxidants and Anti-inflammatory supplements to help alleviate onset of Crisis.",
    icon: vitamins,
  },
  {
    title: "Pain Management",
    text: "Our team has tons of experience in managing acute and chronic pain due to new and ongoing Crisis.  We have various forms of delivery forms: Oral, sublingual, interosseous and intravenous management techniques. We offer more effective options besides the NSAIDS.",
    icon: pain,
  },
];
